var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['accordion-content', { open: _vm.context.isOpen }]},[_c('div',{staticClass:"inner"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.context.isOpen)?_c('div',[_vm._t("default")],2):_vm._e()])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }